import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { SiteStatusProvider } from './context/SiteStatusContext';
import BotNavbar from './components/layout/BotNavbar';
import ToastContainer from './components/ui/ToastContainer';
import LoadingSpinner from './components/ui/LoadingSpinner';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import StaffPage from './pages/StaffPage';
import DocsPage from './pages/DocsPage';
import ChangelogPage from './pages/ChangelogPage';
import ChangelogPostPage from './pages/ChangelogPostPage';
import NotFoundPage from './pages/NotFoundPage';
import { isStaffRole } from './constants/botNav';

/**
 * A bot oldala (bot.mortisengine.com) — 2026-10-07 óta saját projekt (mortis-web\bot-frontend), a Codexével azonos
 * dizájnnal. Terv: C:\ccc\bot-backend-atkoltoztetes.txt (10. és 14. pont).
 *
 * KILÉPVE SZIGORÚAN CSAK A BELÉPŐ LAP látszik, link nélkül (a tulajdonos: „ott szigorúan csak bejelentkezés oldal
 * lenne ha nincs belépve”); minden más cím a belépésre visz, és belépés után oda tér vissza.
 * BELÉPVE: Dashboard (licenc + loader, route-ok, könyvtár, review, farm), Docs, Changelog, és a stábnak a Staff lap.
 * A fiók kezelése (regisztráció, jelszó, vásárlás, előfizetés) a Codex oldalon van.
 */

function SignedOut() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* 2026-10-08: az app saját belépésének regisztrációja — csak a ticketben kapott linkről (nincs rá gomb). */}
      <Route path="/register" element={<RegisterPage />} />
      <Route path="*" element={
        <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
      } />
    </Routes>
  );
}

function SignedIn({ user }) {
  const location = useLocation();
  const from = location.state?.from;
  const back = typeof from === 'string' && from.startsWith('/') && !from.startsWith('/login') ? from : '/licence';

  return (
    <SiteStatusProvider>
      <div className="min-h-screen flex flex-col">
        <BotNavbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Navigate to="/licence" replace />} />
            <Route path="/login" element={<Navigate to={back} replace />} />
            {['/licence', '/routes', '/library', '/review', '/farming'].map(p => (
              <Route key={p} path={p} element={<DashboardPage />} />
            ))}
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/changelog" element={<ChangelogPage />} />
            <Route path="/changelog/:slug" element={<ChangelogPostPage />} />
            <Route path="/staff" element={isStaffRole(user.role) ? <StaffPage /> : <Navigate to="/licence" replace />} />
            {/* A ticketben kapott link belépve is működjön (pl. új jelszó, vagy egy másik fiók munkamenete van nyitva). */}
            <Route path="/register" element={<RegisterPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
      </div>
    </SiteStatusProvider>
  );
}

function Shell() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner fullPage />;
  return user ? <SignedIn user={user} /> : <SignedOut />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Shell />
          <ToastContainer />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
